var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60181",
    "data-name": "Group 60181",
    transform: "translate(-163 -1083)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4779",
    "data-name": "Ellipse 4779",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(163 1083)",
    fill: "#f1f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(180.75 1101.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87718",
    "data-name": "Path 87718",
    d: "M31.514,17.885V28.029a2.938,2.938,0,0,1-2.94,2.94H6.514a2.938,2.938,0,0,1-2.94-2.94V17.885a3.738,3.738,0,0,0,1.93-.754l12.04-9.207,12.04,9.207A3.738,3.738,0,0,0,31.514,17.885Zm-12.43-4.467a.35.35,0,0,0-.65-.221L13.469,21.71a.347.347,0,0,0,0,.351.352.352,0,0,0,.3.177h2.9L16,27.551a.35.35,0,0,0,.65.221l4.966-8.512a.347.347,0,0,0,0-.351.352.352,0,0,0-.3-.177h-2.9Z",
    transform: "translate(1.529 3.782)",
    fill: "#66939e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87719",
    "data-name": "Path 87719",
    d: "M3.2,19.332l-1.414-1.57a2.093,2.093,0,0,1,.265-3.047L17.259,2.8a2.943,2.943,0,0,1,3.628,0L36.094,14.715a2.093,2.093,0,0,1,.265,3.047l-1.414,1.57a2.09,2.09,0,0,1-2.825.262L19.348,9.829a.453.453,0,0,0-.55,0L6.027,19.594A2.09,2.09,0,0,1,3.2,19.332Z",
    fill: "#66939e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87720",
    "data-name": "Path 87720",
    d: "M15.856,4.128V3.655A1.244,1.244,0,0,1,17.1,2.412h5.09a1.243,1.243,0,0,1,1.243,1.243v6.41Z",
    transform: "translate(9.61 0.155)",
    fill: "#66939e",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.ef868da3ebbbf1a70048de58928b576d.svg";
export { ForwardRef as ReactComponent };